// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".transferButton{margin-right:12px}.transferButton button{margin-right:0px}.transferButton svg{padding-top:6px}\n", ""]);
// Exports
module.exports = exports;
